<template>
  <v-container fluid class="webproject-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-project`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Project
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-pages`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Pages
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-containers`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Containers
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-items`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            <span>Items</span>
            <span><sup>{{ this.data_items.length }}</sup></span>
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-media`"
          >
            <v-icon class="mr-3">mdi-image</v-icon>
            Media
          </v-tab>
          <v-tab-item
            :value="'tab-project'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Edit Project</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeProject($event, 'projectcode')"
                        v-bind:value="initvalue.projectcode"
                        placeholder="Project Code"
                        persistent-hint
                        single-line hint="Enter the project code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeProject($event, 'projectname')"
                        v-bind:value="initvalue.projectname"
                        placeholder="Project Name"
                        persistent-hint
                        single-line hint="Enter the project name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=projecttype
                        :value="initvalue.projecttype"
                        outlined
                        dense
                        v-on:change="onChangeProject($event, 'projecttype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the project type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="onChangeProject($event, 'projectstatus')"
                          v-bind:label="initvalue.projectstatus"
                          v-model="initvalue.projectstatus"
                          value="Active"
                      ></v-switch>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/webproject/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editProjectRequest()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-pages'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="8">
                        <p class="text-h5">Web Pages</p>
                      </v-col>
                      <v-col md="4" align="right">
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddPage = true"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-1"
                            to="/webproject/list"
                            replace
                            color="primary"
                          >
                            Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="pagerank"
                        :headers="header_pages"
                        :items="webpages"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeletePage" width="500">
                            <v-card>
                              <v-card-title> Delete this Page? </v-card-title>
                              <v-card-text>
                                {{ delete_page.pagename }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeletePage = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteWebPage(delete_page)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>                    
                        <template v-slot:item.pagepath="{ item }">
                          <p class="two-line"><a :href="`https://web.tradexc.com/${initvalue.projectcode}${item.pagepath}`" target="_blank">{{ item.pagepath }}</a></p>
                        </template>
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editWebPageDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteWebPageDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-containers'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="8">
                        <p class="text-h5">Containers</p>
                      </v-col>
                      <v-col md="4" align="right">
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddContainer = true"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-1"
                            to="/webproject/list"
                            replace
                            color="primary"
                          >
                            Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        item-key="_id"
                        sort-by="containerrank"
                        show-select
                        single-select
                        v-model="container_selected"
                        :headers="header_containers"
                        :items="webcontainers"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteContainer" width="500">
                            <v-card>
                              <v-card-title> Delete this Container? </v-card-title>
                              <v-card-text>
                                {{ delete_container.containername }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteContainer = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteWebContainer(delete_container)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.pageid="{ item }">
                          <p class="two-line">{{ webpages.length>0 ? webpages.find(x=>x._id==item.pageid)['pagename'] : '' }}</p>
                        </template>     
                        <template v-slot:item.containername="{ item }">
                          <p class="two-line">{{ item.containername }}</p>
                          <p class="two-line">{{ item.containercode }}</p>
                        </template>                  
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editWebContainerDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteWebContainerDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-items'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="8">
                        <p class="text-h5">Items</p>
                      </v-col>
                      <v-col md="4" align="right">
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddItem = true"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-1"
                            to="/webproject/list"
                            replace
                            color="primary"
                          >
                            Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="itemrank"
                        :headers="header_items"
                        :items="data_items"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteItem" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ delete_item.itemcode }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteItem = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteWebItem(delete_item)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.itemimage="{ item }">
                          <v-img
                            v-bind:src="item.itemimage"
                            max-height="50"
                            max-width="50"
                          ></v-img>
                        </template>  
                        <template v-slot:item.pageid="{ item }">
                          <p class="two-line" v-if="item.pageid!=undefined">{{ webpages.length>0 && webpages.find(group=>group._id == item.pageid) ? webpages.find(group=>group._id == item.pageid)['pagename'] || '' : ''  }}</p>
                        </template>
                        <template v-slot:item.containerid="{ item }">
                          <p class="two-line" v-if="item.containerid!=undefined">{{ webcontainers.length>0 ? webcontainers.find(x=>x._id == item.containerid)['containername'] : ''  }}</p>
                        </template>
                        <template v-slot:item.itemcode="{ item }">
                          <p class="two-line">{{ item.itemcode }}</p>
                        </template>                    
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editWebItemDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteWebItemDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-media'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="8">
                        <p class="text-h5">Media</p>
                      </v-col>
                      <v-col md="4" align="right">
                        <v-btn
                          class="button-shadow mr-1"
                          color="secondary"
                          @click="isAddMedia = true"
                        >
                          Add
                        </v-btn>
                        <v-btn
                          class="button-shadow mr-1"
                            to="/webproject/list"
                            replace
                            color="primary"
                          >
                            Done
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="itemrank"
                        :headers="header_media"
                        :items="webmedia"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteMedia" width="500">
                            <v-card>
                              <v-card-title> Delete this Media? </v-card-title>
                              <v-card-text>
                                {{ delete_item.mediacode }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteMedia = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteWebMedia(delete_media)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.mediaimage="{ item }">
                          <v-img
                            v-bind:src="item.mediaimage"
                            max-height="50"
                            max-width="50"
                          ></v-img>
                        </template>  
                        <template v-slot:item.mediacode="{ item }">
                          <p class="two-line">{{ item.mediacode }}</p>
                        </template>                    
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editWebMediaDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteWebMediaDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <div>
      <v-dialog
        v-model="isAddPage"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Page</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="2">
                  <v-text-field
                    dense
                    v-model="add_page.pagerank"
                    class="mb-4"
                    placeholder="Num"
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line
                    hint="Num"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="5">
                  <v-select
                    dense
                    class="mb-4"
                    :items="['Main Page', 'Sub Page', 'Form Page']"
                    v-model="add_page.pagetype"
                    v-bind:error="errorindex == 1"
                    placeholder="Type"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="5">
                  <v-text-field
                    dense
                    v-model="add_page.pagepath"
                    label="Path"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    dense
                    v-model="add_page.pagename"
                    label="Name"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    dense
                    v-model="add_page.pagecode"
                    label="Code"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="add_page.pagedata"
                    rows=5
                    label="Data"
                    required
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddPage=false; add_page={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="addWebPageRequest"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditPage"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Page</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-on:change="onChangePage($event, 'pagerank')"
                    :value="edit_page.pagerank"
                    class="mb-4"
                    placeholder="Num"
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line
                    hint="Num"
                    dense
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="5">
                  <v-select
                    dense
                    class="mb-4"
                    :items="['Main Page', 'Sub Page', 'Form Page']"
                    v-on:change="onChangePage($event, 'pagetype')"
                    :value="edit_page.pagetype"
                    v-bind:error="errorindex == 12"
                    placeholder="Type"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="5">
                  <v-text-field
                    dense
                    v-on:change="onChangePage($event, 'pagepath')"
                    :value="edit_page.pagepath"
                    label="Path"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    dense
                    v-on:change="onChangePage($event, 'pagename')"
                    :value="edit_page.pagename"
                    label="Name"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    dense
                    v-on:change="onChangePage($event, 'pagecode')"
                    :value="edit_page.pagecode"
                    label="Code"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="12">
                  <v-textarea
                    v-on:change="onChangePage($event, 'pagedata')"
                    rows=5
                    label="Data"
                    required
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditPage = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editWebPageRequest"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isAddContainer"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Container</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>

              </v-row>
              <v-row>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="add_container.containerrank"
                    class="mb-4"
                    placeholder="Num"
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line
                    hint="Num"
                    dense
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="5">
                  <v-select
                    dense
                    class="mb-4"
                    :items="['Header', 'Banner', 'Body', 'Footer']"
                    v-model="add_container.containertype"
                    v-bind:error="errorindex == 1"
                    placeholder="Type"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="5">
                  <v-select
                    class="mb-4"
                    :items="webpages.map(x => {
                      return {text: x.pagecode, value: x._id};
                    })"
                    v-model="add_container.pageid"
                    v-bind:error="errorindex == 3"
                    placeholder="Page"
                    dense
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    dense
                    v-model="add_container.containername"
                    label="Name"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    dense
                    v-model="add_container.containercode"
                    label="Code"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="add_container.containerdata"
                    rows=5
                    label="Data"
                    required
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddContainer=false; add_container={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="addWebContainerRequest"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditContainer"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Container</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-on:change="onChangeContainer($event, 'containerrank')"
                    :value="edit_container.containerrank"
                    class="mb-4"
                    placeholder="Num"
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line
                    hint="Num"
                    dense
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="5">
                  <v-select
                    dense
                    class="mb-4"
                    :items="['Header', 'Banner', 'Body', 'Footer']"
                    v-on:change="onChangeContainer($event, 'containertype')"
                    :value="edit_container.containertype"
                    v-bind:error="errorindex == 1"
                    placeholder="Type"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="5">
                  <v-select
                    class="mb-4"
                    :items="webpages.map(x => {
                      return {text: x.pagecode, value: x._id};
                    })"
                    v-on:change="onChangeContainer($event, 'pageid')"
                    :value="edit_container.pageid"
                    placeholder="Container"
                    dense
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-on:change="onChangeContainer($event, 'containername')"
                    :value="edit_container.containername"
                    label="Name"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-on:change="onChangeContainer($event, 'containercode')"
                    :value="edit_container.containercode"
                    label="Code"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="edit_container.containerdata"
                    v-on:change="onChangeContainer($event, 'containerdata')"
                    :value="edit_container.containerdata"
                    rows=5
                    label="Data"
                    required
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditContainer = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editWebContainerRequest"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isAddItem"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Item</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="add_item.itemrank"
                    class="mb-4"
                    placeholder="Num"
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line
                    hint="Num"
                    dense
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="5">
                  <v-select
                    class="mb-4"
                    :items="webpages.map(x => {
                      return {text: x.pagecode, value: x._id};
                    })"
                    v-model="add_item.pageid"
                    v-bind:error="errorindex == 3"
                    placeholder="Page"
                    dense
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="5">
                  <v-select
                    class="mb-4"
                    :items="webcontainers
                    .filter(x=>x.pageid==add_item.pageid)
                    .map(x => { return {text: x.containername, value: x._id}})"
                    v-model="add_item.containerid"
                    v-bind:error="errorindex == 3"
                    placeholder="Container"
                    dense
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    dense
                    class="mb-4"
                    :items="['Block', 'Menu', 'Text', 'Image', 'Other']"
                    v-model="add_item.itemtype"
                    v-bind:error="errorindex == 1"
                    placeholder="Type"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    dense
                    v-model="add_item.itemcode"
                    label="Code"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="5">
                  <v-file-input dense label="File input" v-model="new_itemphoto" v-on:change="onChangeItemPhoto" accept="image/*" />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    dense
                    v-model="add_item.itemtitle"
                    label="Title"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    dense
                    v-model="add_item.itemsubtitle"
                    label="Subtitle"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea
                    v-model="add_item.itemdata"
                    rows=5
                    label="Data"
                    required
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddItem=false; add_item={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="addWebItemRequest"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
      v-model="isEditItem"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Item</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeItem($event, 'itemrank')"
                  :value="edit_item.itemrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="webpages.map(x => {return {text: x.pagecode, value: x._id};})"
                  v-on:change="onChangeItem($event, 'pageid')"
                  :value="edit_item.pageid"
                  placeholder="Page"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  class="mb-4"
                  :items="webcontainers.map(x => {
                    return {text: x.containername, value: x._id};
                  })"
                  v-on:change="onChangeItem($event, 'containerid')"
                  :value="edit_item.containerid"
                  placeholder="Container"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="3">
                  <v-select
                    dense
                    class="mb-4"
                    :items="['Block', 'Menu', 'Text', 'Image', 'Other']"
                    v-on:change="onChangeItem($event, 'itemtype')"
                    :value="edit_item.itemtype"
                    v-bind:error="errorindex == 1"
                    placeholder="Type"
                  >
                  </v-select>
                </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  dense
                  v-on:change="onChangeItem($event, 'itemcode')"
                  :value="edit_item.itemcode"
                  label="Code"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-file-input dense label="File input" v-model="edit_itemphoto" v-on:change="onChangeItemPhotoEdit" accept="image/*" />
              </v-col>
              <v-col cols="12" md="6">
                  <v-text-field
                    dense
                    v-on:change="onChangeItem($event, 'itemtitle')"
                    :value="edit_item.itemtitle"
                    label="Title"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    dense
                    v-on:change="onChangeItem($event, 'itemsubtitle')"
                    :value="edit_item.itemsubtitle"
                    label="Subtitle"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-textarea
                    v-on:change="onChangeItem($event, 'itemdata')"
                    :value="edit_item.itemdata"
                    rows=5
                    label="Data"
                    required
                  ></v-textarea>
                </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditItem=false; edit_item={};"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editWebItemRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>

    <!-- 
  <v-row>

  </v-row> -->
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      header_pages: [
        { text: "#", value: "pagerank", width: "10px" },
        { text: "Type", value: "pagetype", width: "10%"  },
        { text: "Name", value: "pagename", width: "15%"  },
        { text: "Code", value: "pagecode", width: "15%"  },
        { text: "Path", value: "pagepath" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      header_containers: [
        { text: "#", value: "containerrank", width: "10px" },
        { text: "Page", value: "pageid", width: "10%" },
        { text: "Type", value: "containertype", width: "10%" },
        { text: "Name & Code", value: "containername" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      header_items: [
        { text: "#", value: "itemrank", width: "10px" },
        { text: "Image", value: "itemimage", width: "10%" }, 
        { text: "Page", value: "pageid", width: "10%" },
        { text: "Container", value: "containerid", width: "15%" },
        { text: "Type", value: "itemtype", width: "10%" },
        { text: "Code", value: "itemcode" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      header_media: [
        { text: "#", value: "mediarank", width: "10px" },
        { text: "Image", value: "mediaimage", width: "10%" }, 
        { text: "Code", value: "mediacode" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      initvalue: {},
      menu: {},
      webpages: [],
      webcontainers: [],
      webitems: [],
      webmedia: [],
      container_selected: [],
      projecttype: ['Web Project', 'Other Web Project'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
      new_itemphoto: null,
      edit_itemphoto: null,
      add_page: {},
      add_container: {},
      add_item: {},
      add_media: {},
      edit_page: {},
      edit_container: {},
      edit_item: {},
      edit_media: {},
      change_menu: {},
      change_page: {},
      change_container: {},
      change_item: {},
      change_media: {},
      delete_page: {},
      delete_container: {},
      delete_item: {},
      delete_media: {},
      isDeletePage: false,
      isDeleteContainer: false,
      isDeleteItem: false,
      isDeleteMedia: false,
      isAddPage: false,
      isAddContainer: false,
      isAddItem: false,
      isAddMedia: false,
      isEditPage: false,
      isEditContainer: false,
      isEditItem: false,
      isEditMedia: false,
    }
  },
  computed: {
    ...mapState('WebProject', ['isReceiving']),
    data_containerid(){
      if(this.container_selected==null || this.container_selected.length==0) return null;
      return this.container_selected[0]['_id'];
    },
    data_items(){
      if(this.data_containerid==null) return [];
      return this.webitems.filter(x=>x.containerid==this.data_containerid);
    },
  },
  watch: {
    // container_selected(){
    //   if(this.container_selected==null || this.container_selected.length==0) {
    //     this.data_schedule = null;
    //     this.shifttimes = [];
    //   }
    //   else {
    //     this.shifttimes = this.data_selected[0]['transactions'];
    //     this.data_schedule = Object.assign(this.data_selected[0]);
    //   }
      
    // }
    
  },
  methods: {
    ...mapActions('WebProject', 
    [ 'getProjectsRequest',
      'deleteWebPageRequest', 'deleteWebContainerRequest', 'deleteWebItemRequest',
      'insertWebPageRequest', 'insertWebContainerRequest', 'insertWebItemRequest', 'insertWebItemWithImageRequest',
      'updateWebProjectRequest','updateWebPageRequest','updateWebContainerRequest','updateWebItemRequest', 'updateWebItemWithImageRequest'
    ]),
    async addWebPageRequest() {
      this.isAddPage = false;
      this.add_page.projectid = this.initvalue._id;
      let result = await this.insertWebPageRequest(this.add_page);
      this.webpages.push(result);
      this.add_page = {};
    },
    async addWebContainerRequest() {
      this.isAddContainer = false;
      this.add_container.projectid = this.initvalue._id;
      console.log(this.add_container)
      let result = await this.insertWebContainerRequest(this.add_container);
      this.webcontainers.push(result);
      this.add_container = {};
    },
    async addWebItemRequest() {
      this.isAddItem = false;
      this.add_item.projectid = this.initvalue._id;
      let result;
      if(this.add_item.imagefile!=undefined && this.add_item.imagefile!=null) {
        result = await this.insertWebItemWithImageRequest(this.add_item)
      }
      else {
        result = await this.insertWebItemRequest(this.add_item)
      }
      this.webitems.push(result);
      this.add_item = {};
    },
    async addWebMediaRequest() {
      this.isAddMedia = false;
      this.add_item.projectid = this.initvalue._id;
      let result;
      if(this.add_item.imagefile!=undefined && this.add_item.imagefile!=null) {
        result = await this.insertWebMediaWithImageRequest(this.add_item)
      }
      else {
        result = await this.insertWebMediaRequest(this.add_item)
      }
      this.webmedia.push(result);
      this.add_media = {};
    },
    deleteWebPageDialog(item) {
      this.isDeletePage = true;
      this.delete_page = { _id: item._id, pagename: item.pagename };
    },
    deleteWebContainerDialog(item) {
      this.isDeleteContainer = true;
      this.delete_container = { _id: item._id, containername: item.containername };
    },
    deleteWebItemDialog(item) {
      this.isDeleteItem = true;
      this.delete_item = { _id: item._id, itemcode: item.itemcode };
    },
    deleteProjectChannelDialog(item) {
      this.isDeleteMedia = true;
      this.delete_media = { _id: item._id, channelname: item.channelname };
    },
    async deleteWebPage(payload) {
      this.isDeletePage = false;
      let response = await this.deleteWebPageRequest(payload);
      let index = this.webpages.findIndex((x) => x._id == response._id);
      this.webpages.splice(index, 1);
    },
    async deleteWebContainer(payload) {
      this.isDeleteContainer = false;
      let response = await this.deleteWebContainerRequest(payload);
      let index = this.webcontainers.findIndex((trans) => trans._id == response._id);
      this.webcontainers.splice(index, 1);
    },
    async deleteWebItem(payload) {
      this.isDeleteItem = false;
      let response = await this.deleteWebItemRequest(payload);
      let index = this.webitems.findIndex((trans) => trans._id == response._id);
      this.webitems.splice(index, 1);
    },
    async deleteProjectChannel(payload) {
      this.isDeleteMedia = false;
      let response = await this.deleteProjectChannelRequest(payload);
      let index = this.webmedia.findIndex((trans) => trans._id == response._id);
      this.webmedia.splice(index, 1);
    },
    editWebPageDialog(item) {
      this.edit_page = Object.assign({}, item);
      this.change_page = {};
      this.isEditPage = true;
    },
    editWebContainerDialog(item) {
      this.edit_container = Object.assign({}, item);
      this.change_container = {};
      this.isEditContainer = true;
    },
    editWebItemDialog(item) {
      this.edit_item = Object.assign({}, item);
      this.change_item = {};
      this.isEditItem = true;
    },
    editProjectChannelDialog(item) {
      this.edit_media = Object.assign({}, item);
      this.change_media = {};
      this.isEditMedia = true;
    },
    async editProjectRequest() {
      this.change_menu._id = this.initvalue._id;
      await this.updateWebProjectRequest(this.change_menu);
      router.push('/webproject/list');
    },
    async editWebPageRequest() {
      this.isEditPage = false;
      this.change_page._id = this.edit_page._id;
      let response = await this.updateWebPageRequest(this.change_page);
      let index = this.webpages.findIndex((x) => x._id == response._id);
      this.webpages.splice(index, 1, response);
      this.edit_page = {};
    },
    async editWebContainerRequest() {
      this.isEditContainer = false;
      this.change_container._id = this.edit_container._id;
      let response = await this.updateWebContainerRequest(this.change_container);
      let index = this.webcontainers.findIndex((x) => x._id == response._id);
      this.webcontainers.splice(index, 1, response);
      this.edit_container = {};
    },
    async editWebItemRequest() {
      this.isEditItem = false;
      this.change_item._id = this.edit_item._id;
      let result;
      if(this.change_item.imagefile!=null) result = await this.updateWebItemWithImageRequest(this.change_item);
      else result = await this.updateWebItemRequest(this.change_item);
      let index = this.webitems.findIndex((x) => x._id == result._id);
      this.webitems.splice(index, 1, result);
      this.edit_item = {};
      this.change_item = {};
    }, 
    async editProjectChannelRequest() {
      this.isEditMedia = false;
      this.change_media.menuitemid = this.edit_media._id;
      let response = await this.updateProjectChannelRequest(this.change_media);
      let index = this.webmedia.findIndex((x) => x._id == response._id);
      this.webmedia.splice(index, 1, response);
      this.edit_media = {};
    },    
    onChangeProject(value, field){
      this.change_menu[field] = value;
    },
    onChangePage(value, field){
      this.change_page[field] = value;
    },
    onChangeContainer(value, field){
      this.change_container[field] = value;
    },
    onChangeItem(value, field){
      this.change_item[field] = value;
    },  
    onChangeChannel(value, field){
      this.change_media[field] = value;
    },
    onChangeItemPhoto(file) {
      if (!file) return;
      this.add_item.imagefile = file;
      this.add_item.imagename = file.name;
      console.log(this.add_item)
    },
    onChangeItemPhotoEdit(file) {
      if (!file) return;
      this.change_item.imagefile = file;
      this.change_item.imagename = file.name;
      console.log(this.add_item)
    },         
  },

  created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'WebProjectList' });
    this.webpages = this.initvalue.pages;
    this.webcontainers = this.initvalue.containers;
    this.webitems = this.initvalue.items;
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
